/* Neverover - size-picker cart flow (desktop, >=768px) + SmartSize + Klarna tweaks.
 * Strictly additive; built on the theme's existing components.
 *   1) "Select Size" placeholder until a size is picked.
 *   2) Add-to-cart with no size opens the dropdown, flags it red + the label to "Select a size".
 *   3) In-stock size click = instant add to cart.
 *   4) Keeps the recommender to one modal + makes it a proportional centred card.
 *   5) Recolours the recommender's grey form panel to white (size chart left untouched).
 *   6) Points the Klarna tooltip "Learn more" link at the payment-methods help article.
 *   7) Tags the recommended size row with a "recommended size / see why" pill after the AI
 *      recommender is used (remembered per size guide / quiz).
 */
(function () {
  if (window.__nvSizeCartFlow) return;
  window.__nvSizeCartFlow = true;

  var UNPICKED = 'nv-size-unpicked';
  var ERROR = 'nv-size-error';
  var PICKED_ATTR = 'data-nv-size-picked';
  var pickedProducts = new Set();

  function desktop() { return window.matchMedia('(min-width: 768px)').matches; }
  function esc(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/([^a-zA-Z0-9_-])/g, '\\$1');
  }
  function pickerOf(node) { return node && node.closest ? node.closest('variant-picker') : null; }
  function productIdOf(vp) { return vp ? vp.getAttribute('data-product-id') : null; }
  function formIdOf(form) { return form && form.getAttribute ? form.getAttribute('id') : null; }
  function sizeOpenersIn(vp) { return vp ? vp.querySelectorAll('dropdown-opener[data-size-input="true"]') : []; }
  function visibleSizeOpeners(root) {
    var list = (root || document).querySelectorAll('dropdown-opener[data-size-input="true"]');
    return Array.prototype.filter.call(list, function (op) {
      var label = op.closest('[data-variant-picker-option-labels]');
      if (label && label.classList.contains('visually-hidden')) return false;
      return op.offsetParent !== null;
    });
  }
  function pickerForForm(formId) {
    if (!formId) return null;
    var radios = document.querySelectorAll('input[type="radio"][form="' + esc(formId) + '"]');
    for (var i = 0; i < radios.length; i++) {
      var vp = radios[i].closest('variant-picker');
      if (vp && vp.getAttribute(PICKED_ATTR) !== null) return vp;
    }
    return radios.length ? radios[0].closest('variant-picker') : null;
  }
  function isUnpicked(vp) { return !!vp && vp.getAttribute(PICKED_ATTR) === 'false'; }
  function isPicked(vp) { return !!vp && vp.getAttribute(PICKED_ATTR) === 'true'; }
  // A size choice is required for this picker if it exposes a size opener at all.
  function needsSize(vp) { return !!vp && sizeOpenersIn(vp).length > 0; }
  // Robustly resolve the variant-picker for an add button so the guard can never silently miss it.
  function vpForAdd(btn) {
    if (!btn) return null;
    var form = btn.form || (btn.closest && btn.closest('form'));
    var vp = pickerForForm(form && form.getAttribute ? form.getAttribute('id') : null);
    if (vp) return vp;
    var scope = (btn.closest && btn.closest('.shopify-section, product-info, .product, main')) || document;
    return scope.querySelector('variant-picker');
  }

  // (2) The "Size" option label text -> "Select a size" (red) while in the no-size error state.
  function sizeLabelSpan(vp) {
    var span = null;
    if (vp && vp.querySelector) {
      span = vp.querySelector('.size-option-label-custom > .heading-font-family')
          || vp.querySelector('[class*="size-option-label"] > .heading-font-family')
          || vp.querySelector('.size-option-label-custom .heading-font-family');
    }
    if (!span) {
      span = document.querySelector('.size-option-label-custom > .heading-font-family')
          || document.querySelector('[class*="size-option-label"] > .heading-font-family');
    }
    return span;
  }
  function setSizeLabelError(vp, on) {
    var span = sizeLabelSpan(vp);
    if (!span) return;
    if (on) {
      if (span.getAttribute('data-nv-orig') === null) span.setAttribute('data-nv-orig', span.textContent);
      span.textContent = 'Select a size';
      span.classList.add('nv-size-label-error');
    } else {
      var orig = span.getAttribute('data-nv-orig');
      if (orig !== null) { span.textContent = orig; span.removeAttribute('data-nv-orig'); }
      span.classList.remove('nv-size-label-error');
    }
  }

  function markPicked(vp) {
    if (!vp) return;
    var pid = productIdOf(vp);
    if (pid) pickedProducts.add(pid);
    vp.setAttribute(PICKED_ATTR, 'true');
    Array.prototype.forEach.call(sizeOpenersIn(vp), function (op) { op.classList.remove(UNPICKED); op.classList.remove(ERROR); });
    setSizeLabelError(vp, false);
  }
  function openSizeDropdown(vp) {
    var op = vp && vp.querySelector('dropdown-opener[data-size-input="true"]');
    if (!op) return;
    if (op.getAttribute('data-aria-expanded') !== 'true') op.click();
    setTimeout(function () {
      var sel = document.querySelector('.variant-picker-dropdown__item.selected');
      if (sel && sel.focus) { try { sel.focus(); } catch (e) {} }
    }, 60);
  }
  function panelIsSize(panel) {
    if (!panel) return false;
    var id = panel.id;
    if (id) {
      if (document.querySelector('dropdown-opener[data-size-input="true"][data-float-element-id="' + esc(id) + '"]')) return true;
      if (document.querySelector('dropdown-opener:not([data-size-input="true"])[data-float-element-id="' + esc(id) + '"]')) return false;
    }
    return visibleSizeOpeners().length > 0;
  }
  function rowSoldOut(item) {
    if (item.hasAttribute('no-available') || item.matches('[no-available]')) return true;
    var bis = item.querySelector('bis-inline, .remind-me-main');
    return !!(bis && bis.offsetParent !== null);
  }
  function injectStyle() {
    if (document.getElementById('nv-size-flow-style')) return;
    var st = document.createElement('style');
    st.id = 'nv-size-flow-style';
    st.textContent =
      '@media (min-width:768px){' +
      '.variant-picker-dropdown__toggle.nv-size-unpicked .selected-value{display:none!important;}' +
      '.variant-picker-dropdown__toggle.nv-size-unpicked .selected-label{display:inline-flex!important;align-items:center;}' +
      '}';
    (document.head || document.documentElement).appendChild(st);
  }
  function initPlaceholders() {
    if (!desktop()) return;
    visibleSizeOpeners().forEach(function (op) {
      var vp = pickerOf(op);
      var pid = productIdOf(vp);
      if (pid && pickedProducts.has(pid)) { if (vp) vp.setAttribute(PICKED_ATTR, 'true'); return; }
      op.classList.add(UNPICKED);
      if (vp && vp.getAttribute(PICKED_ATTR) === null) vp.setAttribute(PICKED_ATTR, 'false');
    });
  }
  function intercept(e, form, btn) {
    var vp = vpForAdd(btn) || pickerForForm(formIdOf(form));
    // Fail CLOSED: a sized product must have an EXPLICIT pick (attr === 'true'). Block on both
    // 'false' AND unset/null so the native submit (which always carries the pre-checked XS) can
    // never slip through when no size was actually chosen.
    if (vp && needsSize(vp) && !isPicked(vp)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var op = vp.querySelector('dropdown-opener[data-size-input="true"]');
      if (op) op.classList.add(ERROR);
      setSizeLabelError(vp, true);
      openSizeDropdown(vp);
      return true;
    }
    return false;
  }
  document.addEventListener('click', function (e) {
    if (!desktop()) return;
    var btn = e.target.closest && e.target.closest('button[name="add"]');
    if (!btn) return;
    intercept(e, btn.form || (btn.closest && btn.closest('form')), btn);
  }, true);
  document.addEventListener('submit', function (e) {
    if (!desktop()) return;
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    intercept(e, form, form.querySelector('button[name="add"]'));
  }, true);
  document.addEventListener('click', function (e) {
    if (!desktop()) return;
    if (!e.isTrusted) return;
    var item = e.target.closest && e.target.closest('.variant-picker-dropdown__item');
    if (!item) return;
    if (!panelIsSize(item.closest('.variant-picker-dropdown'))) return;
    if (rowSoldOut(item)) return;
    var forId = item.getAttribute('for');
    var radio = forId ? document.getElementById(forId) : null;
    if (!radio) return;
    var vp = pickerOf(radio) || pickerForForm(radio.getAttribute('form'));
    setTimeout(function () {
      markPicked(vp);
      var formId = radio.getAttribute('form');
      var form = formId ? document.getElementById(formId) : null;
      var atc = (form && form.querySelector('button[name="add"]')) || document.querySelector('button[name="add"]');
      if (atc && !atc.disabled) atc.click();
      else if (form && form.requestSubmit) form.requestSubmit();
    }, 70);
  }, false);

  // (4) The SmartSize app loads twice on the product page (the app block AND the "Size and fit"
  // size_fit theme block each wire up SmartSize), so there are two #smartrecom-portal-host elements
  // and a modal can render in EITHER. nv-overrides.css hides the 2nd by default (stops the
  // double-modal). On top of that we track the *active* host -- whichever one most recently opened
  // an overlay -- and show ONLY it, hiding the other. That keeps a single modal and fixes the case
  // where the live modal (e.g. the recommender opened right after the size chart) lands in the host
  // the static CSS had hidden, which made it look stuck / unclickable.
  var nvActiveHost = null;
  function nvIsOpen(h) {
    var sr = h.shadowRoot; if (!sr) return false;
    var ov = sr.querySelector('.smartrecom-modal-overlay'); if (!ov) return false;
    var cs = getComputedStyle(ov);
    return ov.getBoundingClientRect().height > 10 && cs.visibility !== 'hidden' && cs.opacity !== '0';
  }
  function manageDuplicateModals() {
    var hosts = document.querySelectorAll('#smartrecom-portal-host');
    if (!hosts.length) return;
    var open = Array.prototype.filter.call(hosts, nvIsOpen);
    if (!open.length) {
      nvActiveHost = null;
      Array.prototype.forEach.call(hosts, function (h) { h.style.removeProperty('display'); });
      return;
    }
    if (!nvActiveHost || open.indexOf(nvActiveHost) === -1) nvActiveHost = open[open.length - 1];
    Array.prototype.forEach.call(hosts, function (h) {
      if (h === nvActiveHost) h.style.setProperty('display', 'block', 'important');
      else if (nvIsOpen(h)) h.style.setProperty('display', 'none', 'important');
      else h.style.removeProperty('display');
    });
  }

  // (5) Inside the recommender / size-chart modal: (a) constrain it to a proportional centred card
  // -- the app leaves .smartrecom-modal-content at max-width:100% and forces min-height:100%, so on
  // desktop it sprawls full-screen; cap width (920) + height (55rem) and let it size to content,
  // scrolling if taller. (b) Recolour the recommender's grey form panel to white, but never the
  // size-chart table, whose own greys are part of its layout.
  var MODAL_CSS =
    '.smartrecom-modal-overlay{align-items:center!important;justify-content:center!important;' +
    'padding:24px!important;background:rgba(0,0,0,0.5)!important;}' +
    '.smartrecom-modal-content{max-width:920px!important;width:100%!important;min-height:auto!important;' +
    'max-height:min(55rem,92vh)!important;margin:auto!important;background:#fff!important;border-radius:14px!important;' +
    'box-shadow:0 24px 70px rgba(0,0,0,0.28)!important;overflow:auto!important;}' +
    '.smartrecom-size-chart{padding:24px!important;}';
  function styleRecommenderModal() {
    var hosts = document.querySelectorAll('#smartrecom-portal-host');
    Array.prototype.forEach.call(hosts, function (host) {
      if (!host.shadowRoot) return;
      var sr = host.shadowRoot;
      if (!sr.querySelector('#nv-modal-style')) {
        var st = document.createElement('style');
        st.id = 'nv-modal-style';
        st.textContent = MODAL_CSS;
        sr.appendChild(st);
      }
      if (host.__nvModalStyled) return;
      host.__nvModalStyled = true;
      var queued = false;
      function recolor() {
        queued = false;
        var nodes = sr.querySelectorAll('div');
        for (var i = 0; i < nodes.length; i++) {
          var n = nodes[i];
          if (n.closest && n.closest('.smartrecom-size-chart')) continue;
          if (getComputedStyle(n).backgroundColor === 'rgb(243, 244, 246)') {
            n.style.setProperty('background-color', '#ffffff', 'important');
          }
        }
      }
      function schedule() { if (queued) return; queued = true; (window.requestAnimationFrame || window.setTimeout)(function () { recolor(); var op = nvIsOpen(host); if (op && !host.__nvWasOpen) nvActiveHost = host; host.__nvWasOpen = op; manageDuplicateModals(); }); }
      recolor();
      try { new MutationObserver(schedule).observe(sr, { childList: true, subtree: true }); } catch (e) {}
    });
  }
  function watchRecommenderHosts() {
    manageDuplicateModals();
    styleRecommenderModal();
    try {
      new MutationObserver(function () { manageDuplicateModals(); styleRecommenderModal(); })
        .observe(document.body, { childList: true });
    } catch (e) {}
  }
  if (document.body) watchRecommenderHosts();
  else document.addEventListener('DOMContentLoaded', watchRecommenderHosts);

  // (6) Point the Klarna installment tooltip "Learn more" link at the payment-methods help
  // article (the widget only renders for RO; on other markets this is a harmless no-op).
  function fixKlarnaLearnMore() {
    var a = document.querySelector('.klarna-static-widget .tooltip a');
    if (a) a.setAttribute('href', '/pages/help/what-payment-methods-are-accepted');
  }

  /* (7) AI size recommender -> "recommended size / see why" pill.
   * SmartRecom.getResult() returns the shopper's recommendation once the quiz is done. We read
   * the recommended size out of it by matching against this product's size options (the size
   * radios, always in the DOM) and remember it in localStorage keyed by the SIZE GUIDE
   * (SmartRecom's quiz), not the product type -- the recommender runs one quiz across a guide
   * (e.g. the unisex quiz covers shorts AND leggings), so the pill carries across every product
   * sharing it. Dropdown rows are lazy (only present while open), so we render on open + on an
   * interval. "see why" reopens the recommender. */
  var RECO_KEY = 'nv_reco_by_guide';
  var AI_ICON =
    '<svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor" aria-hidden="true" focusable="false">' +
    '<path d="M12 1.6l2.46 6.49c.26.69.72 1.15 1.41 1.41L22.4 12l-6.49 2.46c-.69.26-1.15.72-1.41 1.41L12 22.4l-2.46-6.49c-.26-.69-.72-1.15-1.41-1.41L1.6 12l6.49-2.46c.69-.26 1.15-.72 1.41-1.41z"/></svg>';

  function recoStoreRead() { try { return JSON.parse(localStorage.getItem(RECO_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function recoStoreWrite(o) { try { localStorage.setItem(RECO_KEY, JSON.stringify(o)); } catch (e) {} }
  function recoConfig() { return (window.SmartRecom && SmartRecom.config) || null; }
  // Key recommendations by the size guide (SmartRecom quiz), falling back to product type.
  function recoKey() {
    var c = recoConfig();
    if (!c) return null;
    if (c.quizType) return 'quiz:' + String(c.quizType);
    if (c.type) return 'type:' + String(c.type);
    return null;
  }

  // Available size option values - read from the size radios (always in the DOM), not the lazy
  // dropdown rows. Prefer radios on a "Size" option; fall back to all radio values.
  function availableSizes() {
    var rs = document.querySelectorAll('variant-picker input[type="radio"]');
    var sized = [], all = [];
    Array.prototype.forEach.call(rs, function (r) {
      if (!r.value) return;
      var v = String(r.value).trim();
      all.push(v);
      if (/size/i.test(r.getAttribute('name') || '')) sized.push(v);
    });
    return sized.length ? sized : all;
  }

  // Find a recommended size inside SmartRecom's opaque result by matching any string value
  // against the product's size options (size/recommendation-ish keys tried first).
  function findRecoSize(result, sizes) {
    if (!result || !sizes.length) return null;
    var byLower = {};
    sizes.forEach(function (s) { byLower[s.toLowerCase()] = s; });
    var found = null, seen = [];
    function walk(o, depth) {
      if (found || o == null || depth > 6 || seen.indexOf(o) !== -1) return;
      if (typeof o === 'string') { var hit = byLower[o.trim().toLowerCase()]; if (hit) found = hit; return; }
      if (typeof o !== 'object') return;
      seen.push(o);
      var keys = Object.keys(o);
      keys.sort(function (a, b) {
        return (/(size|recommend|result|best|fit)/i.test(a) ? 0 : 1) - (/(size|recommend|result|best|fit)/i.test(b) ? 0 : 1);
      });
      for (var i = 0; i < keys.length; i++) { walk(o[keys[i]], depth + 1); if (found) return; }
    }
    walk(result, 0);
    return found;
  }

  function recoTryCapture() {
    if (!window.SmartRecom || typeof SmartRecom.getResult !== 'function') return;
    var key = recoKey(); if (!key) return;
    var result; try { result = SmartRecom.getResult(); } catch (e) { return; }
    if (!result) return;
    var size = findRecoSize(result, availableSizes());
    if (!size) return;
    var store = recoStoreRead();
    var prev = store[key];
    if (!prev || prev.size !== size) {
      var cfg = recoConfig();
      store[key] = { size: size, pid: cfg ? cfg.productId : null, at: Date.now() };
      recoStoreWrite(store);
    }
  }

  function recoRender() {
    var key = recoKey(); if (!key) return;
    var rec = recoStoreRead()[key];
    var wanted = rec && rec.size ? String(rec.size).toLowerCase() : null;
    var items = document.querySelectorAll('.variant-picker-dropdown__item');
    Array.prototype.forEach.call(items, function (it) {
      var f = it.getAttribute('for');
      var r = f ? document.getElementById(f) : null;
      var val = r && r.value ? String(r.value).trim().toLowerCase() : '';
      var match = wanted && val === wanted;
      var has = it.querySelector('.nv-reco-pill');
      if (match && !has) {
        var pill = document.createElement('span');
        pill.className = 'nv-reco-pill';
        pill.innerHTML = AI_ICON +
          '<span class="nv-reco-label">recommended size</span>' +
          '<span class="nv-reco-sep" aria-hidden="true">.</span>' +
          '<button type="button" class="nv-reco-why">see why</button>';
        it.appendChild(pill);
      } else if (!match && has) {
        has.parentNode.removeChild(has);
      }
    });
  }

  function recoTick() { recoTryCapture(); recoRender(); }
  var recoStarted = false;
  function recoStart() {
    if (recoStarted) return;
    recoStarted = true;
    document.addEventListener('click', function (e) {
      var op = e.target.closest && e.target.closest('dropdown-opener[data-size-input="true"]');
      if (op) { setTimeout(recoRender, 80); setTimeout(recoRender, 260); }
    }, true);
    // "see why" reopens the recommender; swallow the click so it doesn't select the size / add.
    document.addEventListener('click', function (e) {
      var why = e.target.closest && e.target.closest('.nv-reco-why');
      if (!why) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      if (window.SmartRecom && typeof SmartRecom.openModal === 'function') SmartRecom.openModal();
    }, true);
    recoTick();
    setInterval(recoTick, 1500);
  }

  function boot() { injectStyle(); initPlaceholders(); fixKlarnaLearnMore(); recoStart(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
